import i18n from 'i18next';

export function educationLevels() {
  return {
    level1: {
      value: 'Currently in high school',
      label: i18n.t('Currently in high school'),
    },
    level2: {
      value: 'Adult learner, no HS diploma or GED',
      label: i18n.t('Adult learner, no HS diploma or GED'),
    },
    level3: {
      value: 'Have high school diploma or GED',
      label: i18n.t('Have high school diploma or GED'),
    },
    level4: {
      value: 'Some college courses',
      label: i18n.t('Some college courses'),
    },
    level5: {
      value: 'Associate degree',
      label: i18n.t('Associate degree'),
    },
    level6: {
      value: 'Bachelor’s degree',
      label: i18n.t('Bachelor’s degree'),
    },
    level7: {
      value: 'Some graduate courses',
      label: i18n.t('Some graduate courses'),
    },
    level8: {
      value: "Master's degree or two-year graduate credential",
      label: i18n.t("Master's degree or two-year graduate credential"),
    },
    level9: {
      value: 'Doctorate degree or four-year graduate credential',
      label: i18n.t('Doctorate degree or four-year graduate credential'),
    },
  };
}
